/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import GoogleLogin from 'react-google-login';
import axios from 'axios';
import {
  closeModal, signinUser, clearUserStatuses, switchModal, authenticateUser, triggerAuthError, userData,
} from '../../actions';
import Girl from '../../assets/login/girl.svg';
import X from '../../assets/login/x.svg';
import Google from '../../assets/login/google.svg';
import { config } from '../../environment';

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
      email: null,
      password: null,
      emailError: false,
      passwordError: false,
    };
  }

  componentWillUnmount() {
    this.props.clearUserStatuses();
  }

  showModal = () => {
    this.setState((prevState) => ({ clicked: !prevState.clicked }));
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  signIn = () => {
    this.props.clearUserStatuses();
    this.setState((prevState) => {
      return {
        passwordError: !prevState.password,
        emailError: !(/\S+@\S+\.\S+/.test(prevState.email)),
      };
    }, () => {
      if (
        !this.state.passwordError
        && !this.state.emailError
      ) {
        const object = {
          email: this.state.email,
          password: this.state.password,
        };
        this.props.signinUser(object, this.props.history);
      }
    });
  }

  handleGoogleLogin = (googleResponse) => {
    this.props.clearUserStatuses();
    axios.post(`${config.url}/api/google-signin`, { token: googleResponse.tokenId })
      .then((response) => {
        // Successful Google login, but account hasn't been created yet
        if (response.data.newUser) {
          this.props.userData({
            firstName: googleResponse.profileObj.givenName,
            lastName: googleResponse.profileObj.familyName,
            email: googleResponse.profileObj.email,
          });
          this.props.switchModal('Register1');

        // Successful Google login and account exists
        } else if (response.data.token && response.data.userid) {
          this.props.authenticateUser(response.data.token, response.data.userid, this.props.history);

        // Error with Google sign in validation, shouldn't happen
        } else {
          console.log('error validating google sign in credentials');
          this.props.triggerAuthError();
        }
      });
  }

  switchModal = () => {
    this.props.switchModal('ForgotPass');
  }

  render() {
    return (
      <div className="modal">
        <img className="x-icon" onClick={this.props.closeModal} src={X} alt="x" />
        <div className="sign-in-container">
          <img src={Girl} alt="person" />
          <div className="sign-in-body">
            <h2 className="sign-in-header">
              Sign In
            </h2>
            <p className="sign-in-text" style={{ marginBottom: '1vw' }}>
              Continue on the journey to understanding your brain!
            </p>
            <div className="form-container">
              <div className="sign-in-form-row">
                <label htmlFor="e-name" className="label-style">Email</label>
                {this.state.emailError ? <p className="modal-form-error">This email is not valid</p> : null}
                <input type="text" id="ename" name="email" className="sign-in-form-input" autoComplete="off" onChange={this.handleChange} />
              </div>
              <div className="sign-in-form-row">
                <label htmlFor="e-pass" className="label-style">Password</label>
                {this.state.passwordError ? <p className="modal-form-error">This field cannot be left blank</p> : null}
                <input type="password" id="password" name="password" className="sign-in-form-input" autoComplete="off" onChange={this.handleChange} />
              </div>
              <div className="forgot" onClick={() => this.switchModal('ForgotPass')} role="button" tabIndex={0}>
                Forgot Password?
              </div>
              {this.props.authError
                ? <p className="signin-error">The email or password entered is incorrect. Click &apos;Create an Account&apos; if you do not have an account yet.</p>
                : null}
              <div className="sign-in-bubble">
                <input type="button" value="Sign In" className="sign-in-button" onClick={this.signIn} />
              </div>
              <GoogleLogin
                clientId="572189003738-5g61kmudmnt9o324mes7081eh3cat29j.apps.googleusercontent.com"
                render={(renderProps) => (
                  <button className="google-login-button" type="button" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                    <img src={Google} alt="Google" />
                    <p>Sign in with Google</p>
                  </button>
                )}
                buttonText="Login"
                onSuccess={this.handleGoogleLogin}
                onFailure={(response) => { console.log('error', response); }}
                cookiePolicy="single_host_origin"
                icon={false}
              />
              <div className="invite">
                Need an Account?
              </div>
              <div
                className="click-me"
                role="button"
                tabIndex={0}
                onClick={() => { this.props.switchModal('Register1'); }}
              >
                Create an Account
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    toggle: state.modal.clicked,
    authError: state.user.authError,
  }
);

export default connect(mapStateToProps, {
  closeModal, signinUser, clearUserStatuses, switchModal, authenticateUser, triggerAuthError, userData,
})(withRouter(SignIn));
